import { Theme } from "@mui/material/styles";

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export const CHATBOT_PERIOD_TYPE_OPTIONS = [
  { id: "MTH", label: "Aylık" },
  { id: "YRS", label: "Yıllık" },
];

export const CHATBOT_CURRENCY_TYPE_OPTIONS = [
  { id: "TRY", label: "TRY" },
  { id: "USD", label: "USD" },
  { id: "EUR", label: "EUR" },
];

export const CHATBOT_PERIOD_TYPE_LABELS: Record<string, string> =
  Object.fromEntries(
    CHATBOT_PERIOD_TYPE_OPTIONS.map((option) => [option.id, option.label]),
  );

// Doluluk uyarı eşikleri. Bu sayfada ve CloudChatBotReport'ta paylaşılır;
// tek kaynak olmasının sebebi ikisinin birbirinden sapmasını engellemek.
export const chatBotUsageColor =
  (pct: number) =>
  (theme: Theme): string =>
    pct >= 90
      ? theme.palette.error.main
      : pct >= 70
        ? "#ED6C02"
        : theme.palette.success.main;
